import { GalleryId } from './constants';

export const pauseVideo = (elementKey: string): ReturnType<typeof executeVideoAction> =>
  executeVideoAction(elementKey, 'pause');

type MethodKeys<T> = {
  [K in keyof T]: T[K] extends () => any ? K : never; // eslint-disable-line @typescript-eslint/no-explicit-any
}[keyof T] &
  string;

const executeVideoAction = (
  elementKey: string,
  videoAction: MethodKeys<HTMLVideoElement>
): void => {
  const activeVideos = findVideos(elementKey);
  activeVideos?.forEach((video) => video?.[videoAction]?.());
};

const SlideCloneClassname = '.slick-cloned';
const findVideos = (mediaKey: string): HTMLVideoElement[] | undefined => {
  const videoElementCandidates = document
    .getElementById(GalleryId)
    ?.querySelectorAll(`#${mediaKey}`);

  if (!videoElementCandidates) {
    return;
  }
  return Array.from(videoElementCandidates)
    .filter(filterElementsInClonedSlides)
    .flatMap((el) => Array.from(el.getElementsByTagName('video')));
};

const filterElementsInClonedSlides = (el: Element): boolean => !el.closest(SlideCloneClassname);
